import { render, staticRenderFns } from "./ListServices.vue?vue&type=template&id=7242c41c&"
import script from "./ListServices.vue?vue&type=script&lang=js&"
export * from "./ListServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports